import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-options',
  templateUrl: './admin-options.component.html',
  styleUrls: ['./admin-options.component.css']
})
export class AdminOptionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
